export default __webpack_public_path__ + "static/media/List.97a50efa.svg";